import { Component, OnInit } from '@angular/core';
import { ChangeColorEvent } from '../section-theme-color/interfaces/section-theme.interface';

@Component({
  selector: 'app-custom-casino',
  templateUrl: './custom-casino.component.html',
  styleUrls: ['./custom-casino.component.css'],
})
export class CustomCasinoComponent implements OnInit {
  ngOnInit(): void {}

  disabledTheme = true;
  showThemeConfirm = false;

  save() {
    this.showThemeConfirm = true;
  }

  onChangeTheme(colors: ChangeColorEvent) {
    if (
      colors.defaultValues.primary !== colors.primary ||
      colors.defaultValues.secondary !== colors.secondary
    ) {
      this.disabledTheme = false;
    } else {
      this.disabledTheme = true;
    }
  }
}
